import { UploadFileExtensionsEnum, UploadFileTypeEnum } from '@dynamika-shared/types/inventory';
import { validFileTypes } from './detectFileExtension';

export const fileTypeValidation = (
  fileName: string,
  fileType: UploadFileTypeEnum | null
) => {
  if (!fileType) return false;

  const fileExtension = Object.keys(validFileTypes).find(ext =>
    fileName?.endsWith(ext)
  );
  return fileExtension
    ? !validFileTypes[fileExtension as UploadFileExtensionsEnum].includes(fileType)
    : true;
};
